import { Link, useLocation } from 'react-router-dom';
import { CallButton } from '@/components/CallButton';
import { Wordmark } from '@/components/Wordmark';
import { otherLangHref, useLang, useLangHref, useT } from '@/lib/useLang';

/**
 * La nav d'une agence, pas d'un logiciel : ce qu'on fait, comment, qui, combien.
 *
 * `onLanding` distingue les ancres (#method, #team) des liens vers la page
 * d'accueil : depuis un article de blog, `#method` seul ne mènerait nulle part.
 */
export function Header() {
  const t = useT();
  const lang = useLang();
  const { pathname, search } = useLocation();
  const withLang = useLangHref();
  const onLanding = pathname === '/';
  const home = withLang('/');
  const anchor = (hash: string) => (onLanding ? hash : `${home}${hash}`);

  return (
    <header className="nz-header">
      <div className="nz-header__inner">
        <Wordmark to={home} />

        <nav className="nz-nav">
          <a href={anchor('#services')}>{t.navServices}</a>
          <a href={anchor('#method')}>{t.navMethod}</a>
          <a href={anchor('#team')}>{t.navTeam}</a>
          <a href={anchor('#pricing')}>{t.navPricing}</a>
          <Link to={withLang('/blog')}>{t.navBlog}</Link>
        </nav>

        <div className="nz-header__actions">
          {/*
            `otherLangHref` reçoit `search` en entier, et c'est voulu : il mène à
            la même page dans l'autre langue, où `session_id` doit rester. Les
            liens qui CHANGENT de page passent, eux, par `withLang`.

            Le libellé du sélecteur est écrit dans la langue de DESTINATION —
            c'est ce qu'un francophone cherche des yeux sur une page anglaise.
            D'où `lang`/`hrefLang` : sans eux un lecteur d'écran prononce
            « Passer en français » avec une voix anglaise, et les crawlers ne
            savent pas où mène le lien.
          */}
          <Link
            className="nz-lang"
            to={otherLangHref(pathname, search, lang)}
            lang={lang === 'en' ? 'fr' : 'en'}
            hrefLang={lang === 'en' ? 'fr' : 'en'}
            aria-label={lang === 'en' ? 'Passer en français' : 'Switch to English'}
          >
            {lang === 'en' ? 'FR' : 'EN'}
          </Link>
          <CallButton placement="header" />
          <a className="nz-btn-primary" href={anchor('#pricing')}>
            {t.protect}
          </a>
        </div>
      </div>
    </header>
  );
}
